import type { Vec2 } from '../engine/tables/definition';
import { pathLength, pointAlongPath } from '../engine/tables/flowMotion';

export const CABINET_MARGIN = 3.4;

/** Fit the surround as well as the board, leaving room for touch controls. */
export function fitCabinet(
  width: number,
  height: number,
  board: { width: number; height: number },
  touch: boolean,
) {
  const side = touch ? 10 : 24;
  const top = touch ? (width < height ? 72 : 12) : 24;
  const bottom = touch ? (width < height ? 144 : 112) : 24;
  const usableWidth = Math.max(1, width - side * 2);
  const usableHeight = Math.max(1, height - top - bottom);
  const outerWidth = board.width + CABINET_MARGIN * 2;
  const outerHeight = board.height + CABINET_MARGIN * 2;
  const scale = Math.min(usableWidth / outerWidth, usableHeight / outerHeight);
  const left = (width - outerWidth * scale) / 2;
  const upper = top + (usableHeight - outerHeight * scale) / 2;
  return {
    scale,
    offsetX: left + CABINET_MARGIN * scale,
    offsetY: upper + CABINET_MARGIN * scale,
    bounds: {
      left,
      top: upper,
      right: left + outerWidth * scale,
      bottom: upper + outerHeight * scale,
    },
  };
}

/** Evenly spaced chevrons follow the route from entrance to return. */
export function rampDirectionMarkers(points: readonly Vec2[]) {
  const length = pathLength(points);
  if (length < 0.01) return [];
  const count = Math.max(2, Math.min(8, Math.floor(length / 22)));
  const delta = Math.min(0.015, 0.8 / length);
  return Array.from({ length: count }, (_, index) => {
    const t = (index + 0.5) / count;
    const before = pointAlongPath(points, t - delta);
    const after = pointAlongPath(points, t + delta);
    return {
      ...pointAlongPath(points, t),
      angle: Math.atan2(after.y - before.y, after.x - before.x),
    };
  });
}
